import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import useTranslation from "@/i18n/useTranslation";
import { Icon } from "@syarahtech/ui";
var OilFAQ = function OilFAQ(_ref) {
  var _section$content;
  var section = _ref.section;
  var _useState = useState(false),
    showAll = _useState[0],
    setShowAll = _useState[1];
  var _useTranslation = useTranslation(["web_oils"]),
    tShort = _useTranslation.tShort;
  var items = (_section$content = section.content) !== null && _section$content !== void 0 ? _section$content : [];
  if (!items.length) return null;
  return /*#__PURE__*/React.createElement("section", {
    className: "px-4 py-6 md:px-2 md:py-10 md:max-w-[1200px] md:mx-auto"
  }, section.title && /*#__PURE__*/React.createElement("h2", {
    className: "text-xl md:text-[30px] font-bold text-[#00143C] text-center pb-7 md:pb-10"
  }, section.title), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 mt-2"
  }, items.map(function (item, index) {
    var _item$id;
    return /*#__PURE__*/React.createElement("details", {
      key: (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : index,
      name: "oil-faq",
      className: "rounded-lg overflow-hidden group bg-white border border-solid border-[#E6E9EF]".concat(!showAll && index >= 4 ? " hidden" : "")
    }, /*#__PURE__*/React.createElement("summary", {
      className: "flex justify-between items-center gap-3 px-4 py-4 md:px-5 md:py-[18px] cursor-pointer list-none text-sm md:text-[15px] font-bold  text-primary-new md:bg-white [&::-webkit-details-marker]:hidden"
    }, /*#__PURE__*/React.createElement("span", null, item.question), /*#__PURE__*/React.createElement("span", {
      className: "flex-shrink-0 text-[#1B2035] flex items-center"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--keyboard-arrow-down",
      className: "text-primary-new block group-open:hidden",
      width: 6,
      height: 6
    }), /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--keyboard-arrow-up",
      className: "text-primary-new hidden group-open:block",
      width: 6,
      height: 6
    }))), /*#__PURE__*/React.createElement("p", {
      className: "px-4 pb-4 md:px-5 md:pb-[18px] text-[13px] md:text-sm text-[#6B7EA5] leading-relaxed md:bg-white"
    }, item.answer));
  })), items.length > 4 && /*#__PURE__*/React.createElement("button", {
    className: "block mx-auto my-10 px-8 py-3 bg-primary-new  text-white border-0 rounded-lg text-sm font-semibold cursor-pointer transition-colors duration-150",
    onClick: function onClick() {
      return setShowAll(function (v) {
        return !v;
      });
    }
  }, showAll ? tShort("faq/show_less", {
    ns: "web_oils"
  }) : tShort("faq/show_more", {
    ns: "web_oils"
  })));
};
export default OilFAQ;